// extracted by mini-css-extract-plugin
module.exports = {"side_text":"_37AgCI5","input":"_2Czymja"};